import PcseoDoctorSearch from "@jdh-cargo/block-pcseo-doctor-search"
import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { setHospitalTDK } from "utils/hospital"
import styles from '../index.less';
import BreadCrumb from "../BreadCrumb"
import { parseUrl, Template } from "../template"
import { getUrlParam } from '@jdhfe/seouifuncs/dist/tools/getUrlParam';

export default () => {

  const localParams = useParams<Record<any, any>>();
  const pageParam = useMemo(() => {
    const id = localParams?.id;
    return parseUrl(id, { position: {index: 0, provinceId: 0, cityId: 1}, departmentId: 1, pageId: 2 });
  }, []);

  const searchParams = useMemo(() => {
    const p = getUrlParam();
    if (p.pvId) {
      return {
        pvId: p.pvId,
      };
    }
    return undefined;
  }, []);

  return (
    <Template>
      <BreadCrumb title="医生列表"></BreadCrumb>
      <div className={styles.doctor}>
        <PcseoDoctorSearch
          moreUrl=""
          pageShow={true}
          tabJump={true} // tab点击跳转路由
          setTDK={(tabFilter: any) => {
            console.log(tabFilter, 10909909);
            const isAll = !pageParam.cityId && !pageParam.provinceId && !pageParam.departmentId
            if (isAll) {
              setHospitalTDK(
                `京东健康哪个医生好，京东健康推荐医生 - 京东健康互联网医院`,
                `京东健康哪个医生好,京东健康推荐医生`,
                `京东健康为您找到临床工作的专家医生，提供免费、权威的全国医生排名查询。为国内患者提供网上看病、在线开药，线上买药，线上复诊，诊后私人医生等全方位服务`,
              );
              return;
            }
            // 省名
            const posName = pageParam.provinceId ? tabFilter.provinceName:'';
            // 市名
            const cityName = pageParam.cityId ? tabFilter.cityName : ''
            // 科室名
            const departName = pageParam.departmentId ? tabFilter.departmentName : '';
            const totalStr = `${posName}${cityName}${departName}`;

            setHospitalTDK(
              `${totalStr}哪个医生好， ${totalStr}推荐医生 - 京东健康互联网医院`,
              `${totalStr}哪个医生好, ${totalStr}推荐医生`,
              `京东健康为您找到临床工作 ${totalStr}专家医生，提供免费、权威的 ${totalStr}医生排名查询。为内患者提供网上看病、在线开药，线上买药，线上复诊，诊后私人医生等全方位服务`
            )
            
          }}
          listParams={searchParams}
          {...pageParam}
        />
      </div>
    </Template>
  )
}